export default "__VITE_ASSET__BuY05SQ5__"